<template>
  <w-setting-sliding-popup ref="slidingPopup" title="판단주기 설정" width="600px" @open="open" @close="close">
    <div slot="content">
      <div v-if="!addEventRscGetintervalShowFlag">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="vertical-center-box">
            <div class="title-h4">판단주기 목록</div>
            <div class="setting-addel mr-l15">
              <el-button size="mini" @click="clickAddEventGetintervalButton"><i class="fas fa-plus"/></el-button>
              <el-button size="mini" @click="clickDeleteEventGetintervalButton" :disabled="currentRow==0"><i class="fas fa-minus"/></el-button>
            </div>
          </div>
          <div v-if="!addEventRscGetintervalShowFlag">
            <el-button size="small" type="solid"  @click="saveButton" :disabled="!tableDataChangeFlag">저장</el-button>
            <el-button size="small" @click="cancelButton" class="mr-r4" :disabled="!tableDataChangeFlag">취소</el-button>
            <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper :data="eventGetintervalTableData" :column-default="columnDefault" :columns="eventGetintervalTableColumn" ref="eventGetintervalTable"
        @current-change="changeCurrentRow" :pagination="false" style="width:100%;" :show-search-tool="showSearchTool" :show-custom-header="true" highlight-current-row>
          <template slot-scope="scope" slot="input-number-slot">
            <el-input-number v-model="scope.row.rscGetinterval" controls-position="right" :min="1" @change="checkChagneTableData"></el-input-number>
          </template>
        </el-table-wrapper>
      </div>
      <w-add-event-rsc-getinterval v-else @click-back-button="changeAddEventRscGetintervalShowFlag" ref="addEventRscGetinterval"></w-add-event-rsc-getinterval>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <div v-if="addEventRscGetintervalShowFlag">
        <el-button size="large" type="solid" class="mr-r4" @click="saveButton">저장</el-button>
        <el-button size="large" @click="cancelButton">취소</el-button>
      </div>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import { differenceWith, cloneDeep, isEqual, isNil, isEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';
import WAddEventRscGetinterval from './AddEventRscGetinterval';

export default {
  name: 'WEventRscGetintervalSettingPopup',
  components: {
    WAddEventRscGetinterval,
  },
  data() {
    return {
      columnDefault,
      addEventRscGetintervalShowFlag: false,
      showSearchTool: false,
      currentRow: [],
      tableDataChangeFlag: false,
      eventGetintervalTableData: [],
      eventGetintervalTableOriginData: [],
      eventGetintervalTableColumn: [
        {
          prop: 'eventRscGetintervalId',
          label: 'ID',
          searchable: true,
        },
        {
          prop: 'eventRscGetintervalName',
          label: '명칭',
          searchable: true,
        },
        {
          prop: 'rscGetinterval',
          label: '주기(초)',
          scopedSlot: 'input-number-slot',
        },
      ],
    };
  },
  methods: {
    open() {
      this.loadData();
    },
    close() {
      this.addEventRscGetintervalShowFlag = false;
      this.currentRow = [];
    },
    loadData() {
      this.currentRow = [];
      RuleSettingsAPI.getRuleEventRscGetintervalList().then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.eventGetintervalTableData = cloneDeep(result);
          this.eventGetintervalTableOriginData = cloneDeep(result);
          this.$nextTick(() => {
            if (!isEmpty(result)) {
              // this.changeCurrentRow(result[0]);
              this.$refs.eventGetintervalTable.$children[0].setCurrentRow(this.eventGetintervalTableData[0]);
            }
            this.checkChagneTableData();
          });
        }
      });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    clickAddEventGetintervalButton() {
      this.changeAddEventRscGetintervalShowFlag();
    },
    changeAddEventRscGetintervalShowFlag(load) {
      if (!isNil(load)) {
        this.loadData();
      }
      this.addEventRscGetintervalShowFlag = !this.addEventRscGetintervalShowFlag;
    },
    clickDeleteEventGetintervalButton() {
      const target = '판단 주기';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        RuleSettingsAPI.checkUsedEventRscGetinterval(this.currentRow.eventRscGetintervalId).then((response) => {
          if (response.data.success) {
            if (response.data.data) {
              this.$message(msgUtil.getCustomMsgData('이벤트의 판단 주기로 설정되어 있어 삭제할 수 없습니다.'));
            } else {
              RuleSettingsAPI.deleteRuleEventRscGetintervalList(this.currentRow).then((deleteResponse) => {
                if (deleteResponse.data.success) {
                  this.$message(msgUtil.getResultMsgData(action, target, true));
                  this.loadData();
                } else {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }
              }).catch(() => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              });
            }
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    changeCurrentRow(row) {
      this.currentRow = row;
    },
    checkChagneTableData() {
      this.tableDataChangeFlag = !isEqual(this.eventGetintervalTableData, this.eventGetintervalTableOriginData);
    },
    saveButton() {
      if (!this.addEventRscGetintervalShowFlag) {
        const target = '판단 주기';
        const action = msgUtil.action.SAVE;
        RuleSettingsAPI.updateRuleEventRscGetintervalList(differenceWith(this.eventGetintervalTableData, this.eventGetintervalTableOriginData, isEqual)).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      } else {
        this.$refs.addEventRscGetinterval.saveButton();
      }
    },
    cancelButton() {
      if (!this.addEventRscGetintervalShowFlag) {
        this.loadData();
      } else {
        this.addEventRscGetintervalShowFlag = false;
        this.$refs.addEventRscGetinterval.cancelButton();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/EventRscGetintervalSettingPopup.vue